<div class="infosets">
    <p-tabView [(activeIndex)]="activeIndex">
        @if (systemInfo) {
        <p-tabPanel [header]="systemInfo?.title">
            <info-viewer [infoSetView]="systemInfo" [scrollHeight]="scrollHeight" [show]="systemInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (ipAddressInfo) {
        <p-tabPanel [header]="ipAddressInfo?.title">
            <info-viewer [infoSetView]="ipAddressInfo" [scrollHeight]="scrollHeight" [show]="ipAddressInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (vrrpInfo) {
        <p-tabPanel [header]="vrrpInfo?.title">
            <info-viewer [infoSetView]="vrrpInfo" [scrollHeight]="scrollHeight" [show]="vrrpInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (interfaceInfo) {
        <p-tabPanel [header]="interfaceInfo?.title">
            <info-viewer #ifinfo [infoSetView]="interfaceInfo" [bodyCmItems]="interfacesCmItems" selectionMode="single" [scrollHeight]="scrollHeight" [show]="interfaceInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (bridgePortInfo) {
        <p-tabPanel [header]="bridgePortInfo?.title">
            <info-viewer #bpinfo [infoSetView]="bridgePortInfo" [bodyCmItems]="bridgePortsCmItems" selectionMode="none" [scrollHeight]="scrollHeight" [show]="bridgePortInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (lagPortInfo) {
        <p-tabPanel [header]="lagPortInfo?.title">
            <info-viewer [infoSetView]="lagPortInfo" [scrollHeight]="scrollHeight" [show]="lagPortInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (assetInfo) {
        <p-tabPanel [header]="assetInfo?.title">
            <info-viewer [infoSetView]="assetInfo" [scrollHeight]="scrollHeight" [show]="assetInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (linkInfo) {
        <p-tabPanel [header]="linkInfo?.title">
            <info-viewer [infoSetView]="linkInfo" [scrollHeight]="scrollHeight" [show]="linkInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (credentialInfo) {
        <p-tabPanel [header]="credentialInfo?.title">
            <info-viewer [infoSetView]="credentialInfo" [scrollHeight]="scrollHeight" [show]="credentialInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (vlanInfo) {
        <p-tabPanel [header]="vlanInfo?.title">
            <info-viewer [infoSetView]="vlanInfo" [scrollHeight]="scrollHeight" [show]="vlanInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (ipRouteInfo) {
        <p-tabPanel [header]="ipRouteInfo?.title">
            <info-viewer [infoSetView]="ipRouteInfo" [scrollHeight]="scrollHeight" [show]="ipRouteInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (arpInfo) {
        <p-tabPanel [header]="arpInfo?.title">
            <info-viewer [infoSetView]="arpInfo" [scrollHeight]="scrollHeight" [show]="arpInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (stpPortInfo) {
        <p-tabPanel [header]="stpPortInfo?.title">
            <info-viewer [infoSetView]="stpPortInfo" [scrollHeight]="scrollHeight" [show]="stpPortInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (fdbInfo) {
        <p-tabPanel [header]="fdbInfo?.title">
            <info-viewer [infoSetView]="fdbInfo" [scrollHeight]="scrollHeight" [show]="fdbInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (cdpInfo) {
        <p-tabPanel [header]="cdpInfo?.title">
            <info-viewer [infoSetView]="cdpInfo" [scrollHeight]="scrollHeight" [show]="cdpInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (lldpInfo) {
        <p-tabPanel [header]="lldpInfo?.title">
            <info-viewer [infoSetView]="lldpInfo" [scrollHeight]="scrollHeight" [show]="lldpInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (entPhysicalInfo) {
        <p-tabPanel [header]="entPhysicalInfo?.title">
            <info-viewer [infoSetView]="entPhysicalInfo" [scrollHeight]="scrollHeight" [show]="entPhysicalInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (installedSoftwareInfo) {
        <p-tabPanel [header]="installedSoftwareInfo?.title">
            <info-viewer [infoSetView]="installedSoftwareInfo" [scrollHeight]="scrollHeight" [show]="installedSoftwareInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32ComputerSystemInfo) {
        <p-tabPanel [header]="win32ComputerSystemInfo?.title">
            <info-viewer [infoSetView]="win32ComputerSystemInfo" [scrollHeight]="scrollHeight" [show]="win32ComputerSystemInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32OperatingSystemInfo) {
        <p-tabPanel [header]="win32OperatingSystemInfo?.title">
            <info-viewer [infoSetView]="win32OperatingSystemInfo" [scrollHeight]="scrollHeight" [show]="win32OperatingSystemInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32BiosInfo) {
        <p-tabPanel [header]="win32BiosInfo?.title">
            <info-viewer [infoSetView]="win32BiosInfo" [scrollHeight]="scrollHeight" [show]="win32BiosInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32DiskDriveInfo) {
        <p-tabPanel [header]="win32DiskDriveInfo?.title">
            <info-viewer [infoSetView]="win32DiskDriveInfo" [scrollHeight]="scrollHeight" [show]="win32DiskDriveInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32LogicalDiskInfo) {
        <p-tabPanel [header]="win32LogicalDiskInfo?.title">
            <info-viewer [infoSetView]="win32LogicalDiskInfo" [scrollHeight]="scrollHeight" [show]="win32LogicalDiskInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32ProcessorInfo) {
        <p-tabPanel [header]="win32ProcessorInfo?.title">
            <info-viewer [infoSetView]="win32ProcessorInfo" [scrollHeight]="scrollHeight" [show]="win32ProcessorInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32PhysicalMemoryInfo) {
        <p-tabPanel [header]="win32PhysicalMemoryInfo?.title">
            <info-viewer [infoSetView]="win32PhysicalMemoryInfo" [scrollHeight]="scrollHeight" [show]="win32PhysicalMemoryInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (win32ProcessInfo) {
        <p-tabPanel [header]="win32ProcessInfo?.title">
            <info-viewer [infoSetView]="win32ProcessInfo" [scrollHeight]="scrollHeight" [show]="win32ProcessInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (apInfo) {
        <p-tabPanel [header]="apInfo?.title">
            <info-viewer [infoSetView]="apInfo" [scrollHeight]="scrollHeight" [show]="apInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (apIfInfo) {
        <p-tabPanel [header]="apIfInfo?.title">
            <info-viewer [infoSetView]="apIfInfo" [scrollHeight]="scrollHeight" [show]="apIfInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (apClientInfo) {
        <p-tabPanel [header]="apClientInfo?.title">
            <info-viewer [infoSetView]="apClientInfo" [scrollHeight]="scrollHeight" [show]="apClientInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (virtualHostInfo) {
        <p-tabPanel [header]="virtualHostInfo?.title">
            <info-viewer [infoSetView]="virtualHostInfo" [scrollHeight]="scrollHeight" [show]="virtualHostInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (virtualHostTableInfo) {
        <p-tabPanel [header]="virtualHostTableInfo?.title">
            <info-viewer [infoSetView]="virtualHostTableInfo" [scrollHeight]="scrollHeight" [show]="virtualHostTableInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (virtualMachineTableInfo) {
        <p-tabPanel [header]="virtualMachineTableInfo?.title">
            <info-viewer [infoSetView]="virtualMachineTableInfo" [scrollHeight]="scrollHeight" [show]="virtualMachineTableInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (virtualSwitchTableInfo) {
        <p-tabPanel [header]="virtualSwitchTableInfo?.title">
            <info-viewer [infoSetView]="virtualSwitchTableInfo" [scrollHeight]="scrollHeight" [show]="virtualSwitchTableInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (ipPhoneTableInfo) {
        <p-tabPanel [header]="ipPhoneTableInfo?.title">
            <info-viewer [infoSetView]="ipPhoneTableInfo" [scrollHeight]="scrollHeight" [show]="ipPhoneTableInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (ipPhoneInfo) {
        <p-tabPanel [header]="ipPhoneInfo?.title">
            <info-viewer [infoSetView]="ipPhoneInfo" [scrollHeight]="scrollHeight" [show]="ipPhoneInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (portStatusInfo) {
        <p-tabPanel [header]="portStatusInfo?.title">
            <info-viewer [infoSetView]="portStatusInfo" [scrollHeight]="scrollHeight" [show]="portStatusInfo_show"></info-viewer>
        </p-tabPanel>
        }
        @if (!!configInfo && canViewDeviceConfigs) {
        <p-tabPanel [header]="configInfo?.title">
            <config-info-viewer [deviceGuid]="deviceGuid" [deviceName]="deviceName" [infoSetView]="configInfo"></config-info-viewer>
        </p-tabPanel>
        }
        @if (!!notesInfo) {
        <p-tabPanel [header]="notesInfo?.title">
            <notes-info-viewer [deviceGuid]="deviceGuid" [deviceName]="deviceName" [infoSetView]="notesInfo"></notes-info-viewer>
        </p-tabPanel>
        }
        @if (deviceMapInfo) {
        <p-tabPanel header="Map">
            <device-layer2map #devicemap [deviceGuid]="deviceGuid" [isMasterDevice]="isMasterDevice" [show]="deviceMapInfo_show"></device-layer2map>
        </p-tabPanel>
        }
    </p-tabView>

  <single-port-alias-dialog [deviceGuid]="deviceGuid" [ifIndex]="ifIndex"
  [(visible)]="displayIfAliasUpdateDialog"></single-port-alias-dialog>

  <single-port-enable-disable-dialog [deviceGuid]="deviceGuid" [ifIndex]="ifIndex"
  [(visible)]="displayIfEnableDisableDialog"></single-port-enable-disable-dialog>

  <port-poe-status-dialog [deviceGuid]="deviceGuid" [(visible)]="displayIfManagePoeDialog"></port-poe-status-dialog>

  <switch-to-jack-lookup-dialog [deviceGuid]="deviceGuid" [(visible)]="displayIfJackLookupDialog"></switch-to-jack-lookup-dialog>

  <port-access-vlan-dialog [deviceGuid]="deviceGuid" [(visible)]="displayEditAccessVlansDialog"></port-access-vlan-dialog>

</div>
